import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import initialState from '../initialState';
import { TSectionsKeys } from '../../model/IStoreTypes';

export const customiseReducer = createSlice({
  name: 'CustomiseReducer',
  initialState: initialState.customiseInitialState,
  reducers: {
    setPostcode: (state, { payload }: PayloadAction<number>) => {
      state.postcode = payload;
    },
    setAccordionStatus: (state, { payload }: PayloadAction<{ name: TSectionsKeys; expanded: boolean }>) => {
      state.sections[payload.name] = { ...current(state).sections[payload.name], expanded: payload.expanded };
    },
    setSelectedSection: (state, { payload }: PayloadAction<TSectionsKeys>) => {
      state.selectedSection = payload;
    },
    setSpecificationsFeaturesModal: (state, { payload }: PayloadAction<boolean>) => {
      state.specificationsFeaturesModal = payload;
    },
    setIsSecondaryCurrencyDisplay: (state, { payload }: PayloadAction<boolean>) => {
      state.isSecondaryCurrencyDisplay = payload;
    },
  },
});

export const customiseActions = customiseReducer.actions;

export default customiseReducer.reducer;
